import React from 'react';
import { hasValue, setNumberInSessionStorage } from '@r-and-a-shared-ui/utils';
import { FormFieldProps } from '../../fields';
import { hasMeaningfulHtml } from 'libs/common-forms-ui/src/utils';
import classNames from 'classnames';
import RichTextWithAsset, {
  RichTextWithAssetProps,
} from '../../RichTextWithAsset/RichTextWithAsset';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import {
  RichTextWithAssetContainer,
  RichTextWithAssetContainerProps,
} from '@r-and-a-shared-ui/common-ui';
import styles from './PlayerPortalsFormStepPreview.module.scss';
import FormFieldPreview from '../../fields/previewFields/FormFieldPreview/FormFieldPreview';
import { FormFieldPreviewTypes } from '../../fields/config/form-field-preview-config';
import { FormStepProps } from '../../types';
import { STORAGE } from '../../constants';

export interface FormStepPreviewProps extends FormStepProps {
  onClickEditHandler: () => void;
  stepNumber: number;
  stepIndexKey: string;
}

export function PlayerPortalsFormStepPreview(props: FormStepPreviewProps) {
  const {
    fieldsData,
    richTextItems,
    onClickEditHandler,
    stepNumber,
    stepIndexKey,
  } = props;

  const subtitleHtml = props.customHeader?.headerSubTitle ?? '';
  const showSubtitle = hasMeaningfulHtml(subtitleHtml);

  const onClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    onClickEditHandler();
    setNumberInSessionStorage(stepIndexKey, stepNumber || 0);
    window.dispatchEvent(new Event(STORAGE));
  };
  const renderFormFields = (
    fields: FormFieldProps[] | undefined,
  ): React.JSX.Element[] | null => {
    if (!hasValue(fields) || typeof fields === 'undefined') {
      return null;
    }

    return fields.map(fieldProps => {
      return (
        <FormFieldPreview
          key={fieldProps.name}
          fieldType={fieldProps.fieldType as FormFieldPreviewTypes}
          name={fieldProps.name}
          label={fieldProps.label}
          options={fieldProps.options}
          subfields={fieldProps.subfields}
        />
      );
    });
  };

  const renderFormRichTextItems = (
    richTextItems:
      | RichTextWithAssetProps[]
      | RichTextWithAssetContainerProps[]
      | undefined,
  ): React.JSX.Element[] | null => {
    if (!hasValue(richTextItems) || typeof richTextItems === 'undefined') {
      return null;
    }

    return richTextItems.map(richTextItem => {
      if (
        hasValue(
          (richTextItem as RichTextWithAssetContainerProps)
            .richTextWithAssetElements,
        )
      ) {
        return (
          <RichTextWithAssetContainer
            {...(richTextItem as RichTextWithAssetContainerProps)}
            key={(richTextItem as RichTextWithAssetProps)?.key}
          />
        );
      }

      return (
        <RichTextWithAsset
          {...(richTextItem as RichTextWithAssetProps)}
          key={(richTextItem as RichTextWithAssetProps)?.key}
        />
      );
    });
  };

  return (
    <div
      className={classNames(
        styles['form-step'],
        styles[`form-step--${props.stepNumber}`],
      )}
    >
      <span className={styles['linkIconBg']}></span>
      <button
        className={`${styles['pen-icon']}`}
        onClick={onClick}
        aria-label="Click to Edit fields"
        title="Click to Edit fields"
        aria-haspopup="true"
        type="button"
      >
        <FontAwesomeIcon icon={faPen} />
      </button>
      <div className={`${styles['form-step__wrapper']}`}>
        <div className={`${styles['form-step__content']}`}>
          <h2 className={`${styles['form-step__header']}`}>
            {props.customHeader?.headerTitle}
          </h2>
          {showSubtitle && (
            <div
              className={styles['form-step__description']}
              dangerouslySetInnerHTML={{ __html: subtitleHtml }}
            />
          )}
          <div className={`${styles['form-step__grid']}`}>
            {renderFormFields(fieldsData)}
          </div>
        </div>
        {richTextItems && (
          <div className={`${styles['form-step__content']}`}>
            {renderFormRichTextItems(richTextItems)}
          </div>
        )}
      </div>
    </div>
  );
}

export default PlayerPortalsFormStepPreview;
